import httpClient from '@/api/httpClient'

class DashboardApi {
  /**
   * 全体（広告主横断型）のダッシュボードデータを取得する。
   */
  static async fetchWhole({
    // query
    serveStatus = 'all',
    keyword = '',
    sort = 'remainingDays',
    sortType = 'asc',

    // paging
    pageNo = 1,
    pageSize = 100,
  }) {
    const res = await httpClient.post('/ad_report/dashboard', {
      query: {
        serveStatus,
        keyword,
        sort,
        sortType,
      },
      pageNo,
      pageSize,
    })
    return res.data
  }

  static async fetchIOProgress({
    advertiserId,
    // 以下 null の値は optional
    IOIds = null,
    BPIds = null,
    dimensionType, // 'total' ot'daily'
    period = 'total',

    // 'total':全期間,
    // 'yesterday':実行日の前日、
    // 'last_7_days':実行日から過去7日、
    // 'current_month':実行日当月、
    // 'last_month':実行日の先月、
    // object { startDate: '2018-10-01' ,endDate: '2018-10-31' }

    format = null,
    pageNo = null,
    pageSize = null,
  }) {
    const res = await httpClient.post(
      `/ad_report/${advertiserId}/dashboard/insertion_order`,
      {
        query: {
          insertionOrder: {
            ids: IOIds,
          },
          ioBudget: {
            ids: BPIds,
          },
          dimensionType,
          period,
          format,
        },
        pageNo,
        pageSize,
      },
    )
    return res.data
  }
}

export default DashboardApi
